<div class="back-wrapper">

    <div class="verified">
        <h1>OstoBuddy upgrade required</h1>
        <p>Please login on the App to initiate the process</p>
    </div>

</div>